/*
 * Bierpakket samenstellen — hoptimaal.com
 * Voor wie → smaak → soort → aantal → pakket van bieren op voorraad.
 * Per bier wisselen, vastzetten of weghalen; alles in één keer in de
 * winkelwagen; de link in de adresbalk is het pakket (delen/verlanglijstje).
 * Smaak = de vijf profielen van de Smaakwijzer (zelfde assen en afstand).
 * Bron: vat33/shopify-theme/hoptimaal/assets/bierpakket.js
 */
(function () {
  "use strict";

  var root = document.getElementById("bierpakket");
  if (!root) return;

  function leesJson(id, terug) {
    try {
      var el = document.getElementById(id);
      return el ? JSON.parse(el.textContent) || terug : terug;
    } catch (e) {
      return terug;
    }
  }
  var FEED = leesJson("bp-feed", null) || { st: [], br: [], b: [] };
  var REGELS = leesJson("bp-regels", {});
  var STIJLNAAM = leesJson("bp-stijlnamen", {});
  var BEELD = leesJson("bp-beelden", {});
  var GEKOCHT = leesJson("bp-gekocht", null);
  var CTX = leesJson("bp-ctx", {});
  var I = leesJson("bp-i18n", {});
  // De | t-filter levert HTML-escaped tekst (&amp;, &#39;); alles gaat hier als textContent de pagina op
  (function () {
    var dec = document.createElement("textarea");
    for (var k in I) { dec.innerHTML = I[k]; I[k] = dec.value; }
  })();
  var TAAL = (document.documentElement.lang || "nl").slice(0, 2);
  var ROOT = (CTX.root || "/").replace(/\/$/, "");
  function vul(t, w) { return String(t || "").replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return w[k] != null ? w[k] : ""; }); }

  // ---------- smaak (gelijk aan de Smaakwijzer) ----------
  // Assen: bitter, zoet, zuur, gebrand, fruitig, body (0–5)
  var W = [1, 1, 1.6, 1.2, 1, 0.7];
  var PROFIELEN = {
    "zacht-en-rond": { naam: "Zacht & Rond", label: I.p_zacht_en_rond, c: [1.5, 2.1, 0.1, 0.3, 1.9, 2.6], box: "ontdekbox-zacht-en-rond" },
    "fris-en-fruitig": { naam: "Fris & Fruitig", label: I.p_fris_en_fruitig, c: [1.5, 1.0, 0.8, 0.0, 3.1, 2.3], box: "ontdekbox-fris-en-fruitig" },
    "hoppig-en-bitter": { naam: "Hoppig & Bitter", label: I.p_hoppig_en_bitter, c: [3.4, 1.1, 0.0, 0.0, 3.1, 2.9], box: "ontdekbox-hoppig-en-bitter" },
    "donker-en-romig": { naam: "Donker & Romig", label: I.p_donker_en_romig, c: [1.5, 3.3, 0.0, 2.8, 1.0, 4.0], box: "ontdekbox-donker-en-romig" },
    "zonder-alcohol": { naam: "Alcoholarm", label: I.p_alcoholarm, c: null, box: "ontdekbox-zonder-alcohol" },
  };
  var MIX_PROFIELEN = ["zacht-en-rond", "fris-en-fruitig", "hoppig-en-bitter", "donker-en-romig"];
  var GEEN_BIER = ["mede", "cider"];
  var VAT33 = "vat-33";
  var SOORTEN = {
    toegankelijk: { max: 450 },
    mix: { max: 1200, parelElke: 3 }, // elk derde bier mag een parel zijn
    parels: { min: 450, max: 1500 },
  };
  var AANTALLEN = [6, 12, 24];

  function afstand(a, b) {
    var s = 0;
    for (var i = 0; i < 6; i++) s += W[i] * (a[i] - b[i]) * (a[i] - b[i]);
    return s;
  }

  // ---------- bieren uit de feed ----------
  var BIEREN = (FEED.b || []).map(function (b) {
    var st = FEED.st[b[1]] || [];
    var br = (FEED.br || [])[b[7]] || [];
    return {
      h: b[0],
      st: st[0] || "",
      stNaam: STIJLNAAM[st[0]] || st[1] || "",
      prof: st[2] || "", // smaakprofiel van de stijl (Bierschool), Nederlandse sleutelwaarde
      abv: b[2],
      s: String(b[3]).split("").map(Number),
      niv: b[4],
      prijs: b[5],
      vrd: b[6],
      br: br[0] || "",
      ml: b[8],
      r: b[9] / 100,
      id: b[10],
      regel: REGELS[b[0]] || b[11] || "",
    };
  });
  var OP_HANDLE = {};
  BIEREN.forEach(function (x) { OP_HANDLE[x.h] = x; });
  function isAlcoholarm(x) {
    // tot en met 0,5%: wettelijk alcoholvrij (≤ 0,1%) of alcoholarm, valt niet onder de Alcoholwet
    return (x.abv >= 0 && x.abv <= 5) || x.st === "alcoholvrij";
  }
  var gekochtIds = {};
  if (GEKOCHT && typeof GEKOCHT === "object") {
    Object.keys(GEKOCHT).forEach(function (k) {
      var m = String(k).match(/(\d+)$/);
      if (m) gekochtIds[m[1]] = 1;
    });
  }
  var heeftGekocht = Object.keys(gekochtIds).length > 0;

  // Smaakwijzer-uitslag van deze bezoeker (assets/smaakwijzer.js bewaart hem)
  var SW = null;
  try {
    var ruw = JSON.parse(window.localStorage.getItem("hoptimaal_smaakwijzer") || "null");
    if (ruw && PROFIELEN[ruw.profiel] && Date.now() - (ruw.t || 0) < 1000 * 60 * 60 * 24 * 180) SW = ruw;
  } catch (e) {}

  // ---------- staat ----------
  var staat = {
    stap: "start", // start | smaak | stijlen | soort | aantal | pakket
    voor: null,
    smaak: null, // profielsleutel | "mix" | "zelf"
    stijlen: [],
    soort: null,
    aantal: null,
    nieuw: true, // alleen bieren die je nog niet kocht (ingelogd, voor jezelf)
    pakket: [], // [{ b: bier, vast: bool, p: productdata|null, geweigerd: {handle:1} }]
    vorige: {}, // bieren uit het vorige pakket (niet vastgezet)
    gemaild: null, // e-mailadres waarnaar dit pakket gemaild is
    gedeeld: false,
    vervangen: false,
    id: null,
  };

  // ---------- Klaviyo (onsite-script staat al op hoptimaal.com) ----------
  function kl(event, props) {
    try {
      var k = window.klaviyo;
      if (!k) return;
      var p = Object.assign({ Taal: TAAL, Voor: staat.voor || "", Smaak: smaakNaam(), Soort: staat.soort || "", Aantal: staat.pakket.length || staat.aantal || 0 }, props || {});
      if (typeof k.track === "function") k.track(event, p);
      else if (typeof k.push === "function") k.push(["track", event, p]);
    } catch (e) {}
  }
  function smaakNaam() {
    if (PROFIELEN[staat.smaak]) return PROFIELEN[staat.smaak].naam;
    if (staat.smaak === "zelf") return "Zelf: " + staat.stijlen.join(", ");
    return staat.smaak === "mix" ? "Mix" : "";
  }
  function smaakLabel() {
    if (PROFIELEN[staat.smaak]) return PROFIELEN[staat.smaak].label;
    if (staat.smaak === "zelf") return staat.stijlen.length <= 3 ? staat.stijlen.map(function (h) { return STIJLNAAM[h] || h; }).join(", ") : I.smaak_zelf;
    return I.smaak_mix;
  }

  // ---------- helpers ----------
  function el(tag, attrs, kinderen) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === "class") e.className = attrs[k];
      else if (k.slice(0, 2) === "on") e.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null && attrs[k] !== false) e.setAttribute(k, attrs[k] === true ? "" : attrs[k]);
    }
    (kinderen || []).forEach(function (c) {
      if (c == null) return;
      e.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    });
    return e;
  }
  function euro(cent) {
    var bedrag = (cent / 100).toFixed(2);
    return "€" + (TAAL === "en" ? bedrag : bedrag.replace(".", ","));
  }
  // Prijs als bedrag zonder €-teken (17 okt 2026, Tjapco: zoals Coolblue). euro() blijft voor zinnen ("nog €X voor gratis") en mails.
  function prijs(cent) {
    var bedrag = (cent / 100).toFixed(2);
    return TAAL === "en" ? bedrag : bedrag.replace(".", ",");
  }
  function procent(abv10) {
    var t = (abv10 / 10).toFixed(1).replace(/\.0$/, "");
    return TAAL === "en" ? t : t.replace(".", ",");
  }
  function naarBoven() {
    var top = root.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: "smooth" });
  }
  function voet() {
    return el("p", { class: "sw-voet" }, [I.voet]);
  }
  function svgKrat(n) {
    // simpel krat met n flesjes van bovenaf: 6 = 3×2, 12 = 4×3, 24 = 6×4
    var k = n === 6 ? [3, 2] : n === 12 ? [4, 3] : [6, 4];
    var w = 120, h = 84, pad = 8, cw = (w - pad * 2) / k[0], ch = (h - pad * 2) / k[1], r = Math.min(cw, ch) * 0.36;
    var ns = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(ns, "svg");
    svg.setAttribute("viewBox", "0 0 " + w + " " + h);
    svg.setAttribute("class", "bp-krat");
    svg.setAttribute("aria-hidden", "true");
    var rect = document.createElementNS(ns, "rect");
    rect.setAttribute("x", "2"); rect.setAttribute("y", "2"); rect.setAttribute("width", w - 4); rect.setAttribute("height", h - 4);
    rect.setAttribute("fill", "none"); rect.setAttribute("stroke", "currentColor"); rect.setAttribute("stroke-width", "3");
    svg.appendChild(rect);
    for (var i = 0; i < k[0]; i++) for (var j = 0; j < k[1]; j++) {
      var c = document.createElementNS(ns, "circle");
      c.setAttribute("cx", pad + cw * (i + 0.5)); c.setAttribute("cy", pad + ch * (j + 0.5)); c.setAttribute("r", r);
      c.setAttribute("fill", "currentColor");
      svg.appendChild(c);
    }
    return svg;
  }

  // ---------- het rekenwerk ----------
  // Filter op de keuzes; los van smaak (die bepaalt de score)
  function magErin(x, soortPrijs) {
    if (x.vrd < 2) return false; // net genoeg voorraad = kans op 'uitverkocht' bij afrekenen
    var zelf = staat.smaak === "zelf";
    if (zelf) {
      if (staat.stijlen.indexOf(x.st) === -1) return false;
    } else {
      if (GEEN_BIER.indexOf(x.st) !== -1) return false;
      if (staat.smaak === "zonder-alcohol" ? !isAlcoholarm(x) : isAlcoholarm(x)) return false;
    }
    if (SW && staat.smaak === SW.profiel && SW.alcMax && x.abv > SW.alcMax) return false;
    if (soortPrijs.min && x.prijs < soortPrijs.min) return false;
    if (soortPrijs.max && x.prijs > soortPrijs.max) return false;
    if (staat.nieuw && staat.voor !== "cadeau" && heeftGekocht && gekochtIds[x.id]) return false;
    return true;
  }

  // Doel per plek in het pakket: smaakvector (profiel) of stijl (zelf kiezen) + prijsband
  function plekDoel(i) {
    var soort = SOORTEN[staat.soort] || SOORTEN.mix;
    var prijs = { min: soort.min || 0, max: soort.max };
    if (soort.parelElke) prijs = (i % soort.parelElke === soort.parelElke - 1) ? { min: 450, max: 1500 } : { min: 0, max: 600 };
    if (staat.smaak === "zelf") return { stijl: staat.stijlen[i % staat.stijlen.length], prijs: prijs };
    if (staat.smaak === "mix") {
      var mp = PROFIELEN[MIX_PROFIELEN[i % MIX_PROFIELEN.length]];
      return { c: mp.c, prof: mp.naam, prijs: prijs };
    }
    var prof = PROFIELEN[staat.smaak];
    if (!prof || !prof.c) return { c: null, prof: null, prijs: prijs }; // alcoholarm: geen smaakdoel, wel kwaliteit en spreiding
    var c = prof.c;
    // Smaakwijzer gedaan: half de eigen antwoorden, half het profiel (zoals de quiz zelf)
    if (SW && SW.profiel === staat.smaak && SW.v && SW.v.length === 6) c = c.map(function (x, k) { return (x + SW.v[k]) / 2; });
    return { c: c, prof: prof.naam, prijs: prijs };
  }

  function score(x, doel) {
    var s = 0;
    if (doel.c) s += afstand(doel.c, x.s);
    // stijl hoort volgens de Bierschool bij een ander smaakprofiel: alleen als er niets beters is
    if (doel.prof && x.prof && x.prof !== doel.prof) s += 40;
    if (doel.stijl && x.st !== doel.stijl) s += 40; // andere gekozen stijl mag, maar liever de plek-stijl
    var niveau = SW && SW.niveau ? SW.niveau : staat.soort === "toegankelijk" ? 2 : 3;
    if (x.niv > niveau) s += (x.niv - niveau) * 6;
    if (staat.soort === "parels" && x.niv === 1) s += 4;
    s += x.r > 0 ? (3.75 - x.r) * 10 : 2; // Untappd: beter gewaardeerd gaat voor
    if (x.br === VAT33) s -= 3; // onze eigen bieren krijgen wat extra liefde (niet in elk pakket)
    if (staat.vorige[x.h]) s += 10; // 'opnieuw samenstellen' moet ook echt iets nieuws geven
    return s + Math.random() * 6; // elke keer net een ander pakket
  }

  // Hoeveel stijlen passen bij deze keuze? Bepaalt het maximum per stijl:
  // Hoppig & Bitter heeft er twee (IPA, pale ale), Zacht & Rond zeven.
  function aantalStijlen() {
    var prof = PROFIELEN[staat.smaak];
    var gezien = {}, n = 0;
    BIEREN.forEach(function (x) {
      if (gezien[x.st] || !magErin(x, { min: 0, max: 1500 })) return;
      if (prof && prof.c && x.prof && x.prof !== prof.naam) return;
      gezien[x.st] = 1;
      n++;
    });
    return Math.max(1, n);
  }
  function grenzen(n) {
    var stijl = 99;
    if (staat.smaak === "mix") stijl = n <= 6 ? 2 : n <= 12 ? 3 : 5;
    else if (staat.smaak !== "zelf") stijl = Math.max(2, Math.ceil(n / aantalStijlen()));
    return { brouwerij: n >= 24 ? 2 : 1, vat33: n >= 24 ? 2 : 1, stijl: stijl };
  }

  // Kies het beste bier voor plek i dat nog past naast de rest van het pakket.
  // Lukt dat niet, dan stap voor stap ruimer, smaak gaat voor:
  // 0 = streng · 1 = meer per brouwerij/stijl · 2 = ook buiten de prijsband · 3 = ook stijlen uit een ander smaakprofiel
  function kiesVoorPlek(i, pakket, uitsluiten, n) {
    for (var r = 0; r <= 3; r++) {
      var b = zoek(i, pakket, uitsluiten, n, r);
      if (b) return b;
    }
    return null;
  }
  function zoek(i, pakket, uitsluiten, n, ruimte) {
    var doel = plekDoel(i);
    var g = grenzen(n);
    var zelfdeProfiel = ruimte < 3;
    if (ruimte >= 1) { g.brouwerij += 1; g.stijl += 2; }
    if (ruimte >= 2) {
      // liever een klassieker van €3,50 in jouw smaak dan een parel in een smaak die je niet koos
      doel.prijs = { min: 0, max: staat.soort === "toegankelijk" ? 600 : 1500 };
    }
    var inPakket = {}, perBr = {}, perSt = {}, vat = 0;
    pakket.forEach(function (p, j) {
      if (!p || j === i) return;
      inPakket[p.b.h] = 1;
      perBr[p.b.br] = (perBr[p.b.br] || 0) + 1;
      perSt[p.b.st] = (perSt[p.b.st] || 0) + 1;
      if (p.b.br === VAT33) vat++;
    });
    var beste = null, min = Infinity;
    for (var k = 0; k < BIEREN.length; k++) {
      var x = BIEREN[k];
      if (inPakket[x.h] || (uitsluiten && uitsluiten[x.h])) continue;
      if (!magErin(x, doel.prijs)) continue;
      if (zelfdeProfiel && doel.prof && x.prof && x.prof !== doel.prof) continue;
      if (x.br && (perBr[x.br] || 0) >= g.brouwerij) continue;
      if ((perSt[x.st] || 0) >= g.stijl) continue;
      if (x.br === VAT33 && vat >= g.vat33) continue;
      var sc = score(x, doel);
      if (sc < min) { min = sc; beste = x; }
    }
    return beste;
  }

  function stelSamen(n) {
    var pakket = [];
    // vastgezette bieren blijven staan
    staat.pakket.forEach(function (p) { if (p.vast) pakket.push({ b: p.b, vast: true, p: p.p, geweigerd: {} }); });
    for (var i = pakket.length; i < n; i++) {
      var b = kiesVoorPlek(i, pakket, null, n);
      if (!b) break;
      pakket.push({ b: b, vast: false, p: null, geweigerd: {} });
    }
    // drinkvolgorde: van licht naar stevig
    pakket.sort(function (a, c) { return a.b.abv - c.b.abv || a.b.niv - c.b.niv; });
    return pakket;
  }

  function schatting(n) {
    // gemiddelde van drie proefpakketten, alleen voor de prijsindicatie bij 'hoeveel bieren'
    var bewaar = staat.pakket, som = 0;
    staat.pakket = [];
    for (var t = 0; t < 3; t++) som += stelSamen(n).reduce(function (s, p) { return s + p.b.prijs; }, 0);
    staat.pakket = bewaar;
    return Math.round(som / 3 / 50) * 50;
  }

  // ---------- productdata (titel, beeld, variant) ----------
  var CACHE = {};
  function haalProduct(handle) {
    if (CACHE[handle]) return CACHE[handle];
    CACHE[handle] = fetch(ROOT + "/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return CACHE[handle];
  }
  function variant(p) {
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return null;
  }
  // Vul productdata aan; wat toch uitverkocht is wordt vervangen
  function laadProducten(pogingen) {
    pogingen = pogingen || 0;
    return Promise.all(staat.pakket.map(function (p) { return p.p ? p.p : haalProduct(p.b.h); })).then(function (lijst) {
      var opnieuw = false;
      lijst.forEach(function (prod, i) {
        var plek = staat.pakket[i];
        // zonder foto oogt een pakket rommelig: ook dan een vergelijkbaar bier kiezen
        if (prod && variant(prod) && prod.featured_image) { plek.p = prod; return; }
        BIEREN = BIEREN.filter(function (x) { return x.h !== plek.b.h; });
        var nieuw = kiesVoorPlek(i, staat.pakket, plek.geweigerd, staat.pakket.length);
        if (nieuw) { staat.pakket[i] = { b: nieuw, vast: false, p: null, geweigerd: plek.geweigerd }; opnieuw = true; }
        else staat.pakket[i] = null;
      });
      staat.pakket = staat.pakket.filter(Boolean);
      if (opnieuw && pogingen < 3) return laadProducten(pogingen + 1);
    });
  }

  // Alles wat de mail "Je pakket staat nog klaar" nodig heeft (Klaviyo-sjabloon Viqe42,
  // bron docs/hoptimaal/bierpakket-herinnering.html). De flow stuurt alleen op het
  // laatste event: een nieuwer "Bierpakket Samengesteld" haalt een eerder pakket uit de flow.
  function pakketEvent() {
    var som = totaal();
    return {
      Aantal: staat.pakket.length,
      SmaakLabel: smaakLabel(),
      Totaal: euro(som),
      TotaalBedrag: som / 100,
      NogVoorGratis: CTX.gratis && som < CTX.gratis ? euro(CTX.gratis - som) : "",
      GratisBereikt: !!(CTX.gratis && som >= CTX.gratis), // buiten NL kennen we de drempel niet: dan niets beloven
      Link: pakketUrl(),
      Pakket: staat.id,
      Bieren: staat.pakket.map(function (p) {
        var prod = p.p || {};
        var v = variant(p.p);
        var beeld = prod.featured_image || "";
        if (beeld.slice(0, 2) === "//") beeld = "https:" + beeld;
        return {
          handle: p.b.h,
          titel: prod.title || p.b.h,
          beeld: beeld ? beeld + (beeld.indexOf("?") > -1 ? "&" : "?") + "width=200" : "",
          stijl: STIJLNAAM[p.b.st] || p.b.stNaam,
          regel: p.b.regel || "",
          prijs: prijs(v ? v.price : p.b.prijs),
          url: window.location.origin + ROOT + "/products/" + p.b.h,
        };
      }),
    };
  }
  var updateTimer = null;
  function meldPakketLater() {
    // na wisselen/weghalen/toevoegen: één nieuw event als de bezoeker even niets meer verandert
    clearTimeout(updateTimer);
    updateTimer = setTimeout(function () { kl("Bierpakket Samengesteld", pakketEvent()); }, 45000);
  }

  function totaal() {
    return staat.pakket.reduce(function (s, p) {
      var v = variant(p.p);
      return s + (v ? v.price : p.b.prijs);
    }, 0);
  }

  // ---------- deellink: de adresbalk ís het pakket ----------
  function pakketUrl() {
    var u = new URL(window.location.href);
    u.searchParams.delete("smaak");
    u.searchParams.delete("voor");
    u.searchParams.set("p", staat.pakket.map(function (p) { return p.b.h; }).join("."));
    u.searchParams.set("k", [staat.voor === "cadeau" ? "c" : "m", staat.smaak || "", staat.soort || "", staat.stijlen.join("+")].join("~"));
    return u.toString();
  }
  function bewaarInUrl() {
    try { window.history.replaceState(null, "", pakketUrl()); } catch (e) {}
  }
  function leesUitUrl() {
    var q = new URLSearchParams(window.location.search);
    var p = q.get("p");
    if (!p) return false;
    var k = (q.get("k") || "").split("~");
    staat.voor = k[0] === "c" ? "cadeau" : "mezelf";
    staat.smaak = PROFIELEN[k[1]] || k[1] === "mix" || k[1] === "zelf" ? k[1] : "mix";
    staat.soort = SOORTEN[k[2]] ? k[2] : "mix";
    staat.stijlen = (k[3] || "").split("+").filter(Boolean);
    if (staat.smaak === "zelf" && !staat.stijlen.length) staat.smaak = "mix";
    staat.nieuw = false; // een gedeeld pakket laten we zoals het is
    var handles = p.split(".").filter(Boolean).slice(0, 48);
    staat.pakket = handles.map(function (h) { return OP_HANDLE[h] ? { b: OP_HANDLE[h], vast: true, p: null, geweigerd: {} } : null; });
    var missend = staat.pakket.filter(function (x) { return !x; }).length;
    staat.pakket = staat.pakket.filter(Boolean);
    staat.aantal = handles.length;
    if (missend) {
      staat.vervangen = true;
      var aangevuld = stelSamen(handles.length);
      staat.pakket = aangevuld;
    }
    staat.pakket.forEach(function (x) { x.vast = false; });
    staat.gedeeld = true;
    staat.id = "BP-DEEL-" + Date.now().toString(36).toUpperCase(); // in bestellingen: via een gedeelde link
    staat.stap = "pakket";
    return true;
  }

  // ---------- schermen ----------
  var STAPPEN = ["smaak", "soort", "aantal"];
  function render() {
    root.innerHTML = "";
    if (zweef && staat.stap !== "pakket") zweef.classList.remove("is-aan");
    root.classList.toggle("bp--pakket", staat.stap === "pakket");
    if (staat.stap === "start") return renderStart();
    if (staat.stap === "smaak") return renderSmaak();
    if (staat.stap === "stijlen") return renderStijlen();
    if (staat.stap === "soort") return renderSoort();
    if (staat.stap === "aantal") return renderAantal();
    return renderPakket();
  }
  function ga(stap) {
    staat.stap = stap;
    render();
    naarBoven();
  }

  function optieKnop(o, klik, gekozen) {
    return el("button", { type: "button", class: "sw-optie" + (gekozen ? " is-gekozen" : "") + (o.extra ? " " + o.extra : ""), onclick: klik }, [
      o.badge ? el("span", { class: "bp-badge" }, [o.badge]) : null,
      o.beeld && BEELD[o.beeld] ? el("img", { src: BEELD[o.beeld], alt: "", width: "180", height: "180", loading: "eager" }) : null,
      o.svg || null,
      el("span", { class: "sw-optie__t" }, [o.t]),
      o.sub ? el("span", { class: "sw-optie__sub" }, [o.sub]) : null,
    ]);
  }

  function balk(n, terugNaar) {
    var totaalStappen = STAPPEN.length + 1;
    return el("div", { class: "sw-balk" }, [
      el("button", { type: "button", class: "sw-terug", "aria-label": I.vorige, onclick: function () { ga(terugNaar); } }, ["←"]),
      el("div", { class: "sw-voortgang", role: "progressbar", "aria-valuemin": "0", "aria-valuemax": String(totaalStappen), "aria-valuenow": String(n) }, [
        el("span", { style: "width:" + Math.round((n / totaalStappen) * 100) + "%" }),
      ]),
      el("span", { class: "sw-teller" }, [n + "/" + totaalStappen]),
    ]);
  }

  function renderStart() {
    root.appendChild(
      el("div", { class: "sw-start" }, [
        el("p", { class: "sw-kicker" }, [I.kicker]),
        el("h1", { class: "sw-titel" }, [I.start_titel]),
        el("p", { class: "sw-intro" }, [I.start_intro]),
        el("div", { class: "sw-opties sw-opties--2" }, [
          optieKnop({ t: I.voor_mezelf, beeld: "voor-mezelf" }, function () { begin("mezelf"); }),
          optieKnop({ t: I.cadeau, beeld: "cadeau" }, function () { begin("cadeau"); }),
        ]),
        voet(),
      ])
    );
  }
  var gestart = false;
  function begin(voor) {
    staat.voor = voor;
    if (!gestart) kl("Bierpakket Gestart");
    gestart = true;
    ga("smaak");
  }

  function renderSmaak() {
    var opties = [];
    var volgorde = Object.keys(PROFIELEN);
    // De eigen Smaakwijzer-uitslag (alleen voor jezelf) staat voorop en valt op
    if (SW && staat.voor !== "cadeau") volgorde = [SW.profiel].concat(volgorde.filter(function (k) { return k !== SW.profiel; }));
    volgorde.forEach(function (k) {
      var p = PROFIELEN[k];
      var eigen = SW && staat.voor !== "cadeau" && SW.profiel === k;
      opties.push(optieKnop({ t: p.label, beeld: p.box, badge: eigen ? I.uit_smaakwijzer : null, extra: eigen ? "bp-optie--eigen" : "" }, function () { kiesSmaak(k); }, staat.smaak === k));
    });
    opties.push(optieKnop({ t: I.o_mix, sub: I.o_mix_sub, extra: "bp-optie--tekst" }, function () { kiesSmaak("mix"); }, staat.smaak === "mix"));
    opties.push(optieKnop({ t: I.o_zelf, sub: I.o_zelf_sub, extra: "bp-optie--tekst" }, function () { staat.smaak = "zelf"; ga("stijlen"); }, staat.smaak === "zelf"));
    root.appendChild(
      el("div", { class: "sw-vraag" }, [
        balk(1, "start"),
        el("h2", { class: "sw-vraag__t" }, [staat.voor === "cadeau" ? I.v_smaak_c : I.v_smaak]),
        el("div", { class: "sw-opties sw-opties--4 bp-smaken" }, opties),
        !SW ? el("p", { class: "bp-hint" }, [el("a", { href: CTX.smaakwijzer }, [I.geen_idee])]) : null,
      ])
    );
  }
  function kiesSmaak(k) {
    staat.smaak = k;
    ga("soort");
  }

  function renderStijlen() {
    // alleen stijlen met genoeg bieren op voorraad
    var tel = {};
    BIEREN.forEach(function (x) { if (x.vrd >= 2) tel[x.st] = (tel[x.st] || 0) + 1; });
    var stijlen = Object.keys(tel).filter(function (h) { return tel[h] >= 2; });
    stijlen.sort(function (a, b) { return (STIJLNAAM[a] || a).localeCompare(STIJLNAAM[b] || b, TAAL); });
    var verder = el("button", { type: "button", class: "sw-knop", disabled: !staat.stijlen.length, onclick: function () { ga("soort"); } }, [I.stijlen_verder]);
    var chips = stijlen.map(function (h) {
      var knop = el("button", { type: "button", class: "bp-chip" + (staat.stijlen.indexOf(h) !== -1 ? " is-gekozen" : ""), "aria-pressed": staat.stijlen.indexOf(h) !== -1 ? "true" : "false" }, [STIJLNAAM[h] || h]);
      knop.addEventListener("click", function () {
        var i = staat.stijlen.indexOf(h);
        if (i === -1) staat.stijlen.push(h);
        else staat.stijlen.splice(i, 1);
        knop.classList.toggle("is-gekozen", i === -1);
        knop.setAttribute("aria-pressed", i === -1 ? "true" : "false");
        verder.disabled = !staat.stijlen.length;
      });
      return knop;
    });
    root.appendChild(
      el("div", { class: "sw-vraag" }, [
        balk(1, "smaak"),
        el("h2", { class: "sw-vraag__t" }, [I.v_stijlen]),
        el("p", { class: "bp-hint bp-hint--links" }, [I.stijlen_hulp]),
        el("div", { class: "bp-chips" }, chips),
        el("div", { class: "sw-knoppen bp-verder" }, [verder]),
      ])
    );
  }

  function renderSoort() {
    var opties = [
      { k: "toegankelijk", t: I.o_toegankelijk, sub: I.o_toegankelijk_sub },
      { k: "mix", t: I.o_mixsoort, sub: I.o_mixsoort_sub },
      { k: "parels", t: I.o_parels, sub: I.o_parels_sub },
    ];
    root.appendChild(
      el("div", { class: "sw-vraag" }, [
        balk(2, staat.smaak === "zelf" ? "stijlen" : "smaak"),
        el("h2", { class: "sw-vraag__t" }, [I.v_soort]),
        el("div", { class: "sw-opties sw-opties--3 bp-soorten" }, opties.map(function (o) {
          return optieKnop({ t: o.t, sub: o.sub, extra: "bp-optie--tekst" }, function () { staat.soort = o.k; ga("aantal"); }, staat.soort === o.k);
        })),
      ])
    );
  }

  function renderAantal() {
    var opties = AANTALLEN.map(function (n) {
      var bedrag = schatting(n);
      var gratis = CTX.gratis && bedrag >= CTX.gratis;
      return optieKnop(
        { t: vul(I.o_aantal, { n: n }), sub: vul(I.schatting, { bedrag: euro(bedrag) }), svg: svgKrat(n), badge: gratis ? I.gratis_verzending : null },
        function () { staat.aantal = n; maakPakket(); },
        staat.aantal === n
      );
    });
    root.appendChild(
      el("div", { class: "sw-vraag" }, [
        balk(3, "soort"),
        el("h2", { class: "sw-vraag__t" }, [I.v_aantal]),
        el("div", { class: "sw-opties sw-opties--3 bp-aantallen" }, opties),
      ])
    );
  }

  function maakPakket() {
    staat.vorige = {};
    staat.gemaild = null;
    staat.gedeeld = false;
    staat.vervangen = false;
    staat.pakket = stelSamen(staat.aantal);
    staat.id = "BP-" + Date.now().toString(36).toUpperCase();
    staat.stap = "pakket";
    root.innerHTML = "";
    root.appendChild(el("p", { class: "sw-laden bp-laden" }, [I.laden]));
    naarBoven();
    laadProducten().then(function () {
      render();
      bewaarInUrl();
      kl("Bierpakket Samengesteld", pakketEvent());
    });
  }

  function renderPakket() {
    var n = staat.pakket.length;
    var kop = el("div", { class: "bp-kop" }, [
      el("p", { class: "sw-kicker" }, [staat.gedeeld ? I.gedeeld : staat.voor === "cadeau" ? I.pakket_ontvanger : I.jouw_pakket]),
      el("h2", { class: "sw-titel" }, [vul(I.resultaat_titel, { n: n }) + " · " + smaakLabel()]),
      el("p", { class: "sw-intro" }, [staat.gedeeld ? I.gedeeld_intro : I.resultaat_intro]),
      staat.vervangen ? el("p", { class: "bp-melding" }, [I.vervangen]) : null,
      n < (staat.aantal || 0) && !staat.gedeeld ? el("p", { class: "bp-melding" }, [I.te_weinig]) : null,
    ]);

    var opties = null;
    if (CTX.klant && heeftGekocht && staat.voor !== "cadeau") {
      var vink = el("input", { type: "checkbox", checked: staat.nieuw });
      vink.addEventListener("change", function () {
        staat.nieuw = vink.checked;
        opnieuwSamenstellen();
      });
      opties = el("label", { class: "bp-vink" }, [vink, el("span", {}, [I.nieuw_voor_jou])]);
    }

    var raster = el("div", { class: "bp-raster" }, staat.pakket.map(function (p, i) { return kaart(p, i); }));
    var toevoegen = el("button", { type: "button", class: "bp-plus", onclick: bierErbij }, ["+ " + I.toevoegen]);

    root.appendChild(
      el("div", { class: "bp-pakket" }, [
        kop,
        opties,
        raster,
        el("div", { class: "bp-onder" }, [
          toevoegen,
          el("button", { type: "button", class: "sw-geen", onclick: opnieuwSamenstellen }, [I.opnieuw]),
          el("button", { type: "button", class: "sw-geen", onclick: function () { staat.pakket = []; ga("smaak"); } }, [I.andere_keuzes]),
        ]),
        staat.voor === "cadeau" && !staat.gedeeld ? el("p", { class: "bp-hint bp-hint--links" }, [I.delen_cadeau]) : null,
        afrekenBalk(),
        mailMij(),
        voet(),
      ])
    );
    zweefBalk();
  }

  // Zwevende mini-balk (totaal + knop) zolang de echte afrekenbalk uit beeld is.
  // Fixed i.p.v. sticky: het thema zet overflow op een ouder, dan werkt sticky niet.
  var zweef = null, kijker = null;
  function zweefBalk() {
    if (zweef) zweef.remove();
    if (kijker) kijker.disconnect();
    zweef = null;
    var echt = root.querySelector(".bp-afreken");
    if (!echt || !("IntersectionObserver" in window)) return;
    var knop = el("button", { type: "button", class: "sw-knop", onclick: function () {
      var hoofd = echt.querySelector(".bp-afrekenen");
      if (hoofd && !hoofd.disabled) allesInWagen(hoofd);
      echt.scrollIntoView({ behavior: "smooth", block: "end" }); // daar staat de bevestiging + link naar de winkelwagen
    } }, [I.alles_in_wagen]);
    zweef = el("div", { class: "bp-zweef", "aria-hidden": "true" }, [
      el("p", { class: "bp-totaal" }, [el("span", {}, [vul(I.resultaat_titel, { n: staat.pakket.length })]), el("strong", {}, [prijs(totaal())])]),
      knop,
    ]);
    document.body.appendChild(zweef);
    kijker = new IntersectionObserver(function (e) {
      var zichtbaar = e[0].isIntersecting || e[0].boundingClientRect.top < 0;
      zweef.classList.toggle("is-aan", !zichtbaar && staat.stap === "pakket");
    });
    kijker.observe(echt);
  }

  function kaart(p, i) {
    var prod = p.p || {};
    var v = variant(p.p);
    var titel = prod.title || p.b.h;
    var url = prod.url ? ROOT + prod.url.replace(/^\/(en|de|nl)(?=\/)/, "") : ROOT + "/products/" + p.b.h;
    var beeld = prod.featured_image ? prod.featured_image + (prod.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=300" : null;
    var stijl = p.b.st && STIJLNAAM[p.b.st]
      ? el("a", { href: CTX.bierschool + p.b.st, title: vul(I.stijl_link_titel, { stijl: STIJLNAAM[p.b.st] }) }, [STIJLNAAM[p.b.st]])
      : p.b.stNaam;
    var info = [];
    if (p.b.ml > 0) info.push(p.b.ml);
    return el("div", { class: "bp-bier" + (p.vast ? " is-vast" : "") }, [
      el("span", { class: "bp-bier__nr" }, [String(i + 1)]),
      el("a", { class: "bp-bier__beeld", href: url }, [beeld ? el("img", { src: beeld, alt: titel, loading: "lazy" }) : null]),
      el("div", { class: "bp-bier__info" }, [
        el("a", { class: "sw-bier__titel", href: url }, [titel]),
        el("p", { class: "sw-bier__stijl" }, [stijl]),
        p.b.regel ? el("p", { class: "sw-bier__regel" }, [p.b.regel]) : null,
        el("p", { class: "bp-bier__meta" }, [
          el("strong", {}, [prijs(v ? v.price : p.b.prijs)]),
          p.b.abv >= 0 ? " · " + (p.b.ml > 0 ? vul(I.bier_info, { ml: p.b.ml, abv: procent(p.b.abv) }) : procent(p.b.abv) + "%") : "",
        ]),
      ]),
      el("div", { class: "bp-bier__acties" }, [
        el("button", { type: "button", class: "bp-actie", onclick: function () { wissel(i); } }, ["↻ " + I.wissel]),
        el("button", { type: "button", class: "bp-actie" + (p.vast ? " is-aan" : ""), "aria-pressed": p.vast ? "true" : "false", onclick: function () { p.vast = !p.vast; render(); } }, [p.vast ? "✓ " + I.vast : I.vastzetten]),
        el("button", { type: "button", class: "bp-actie bp-actie--weg", "aria-label": I.weghalen, title: I.weghalen, onclick: function () { weghalen(i); } }, ["×"]),
      ]),
    ]);
  }

  function afrekenBalk() {
    var som = totaal();
    var meter = null;
    if (CTX.gratis) {
      var rest = CTX.gratis - som;
      meter = el("div", { class: "bp-meter" + (rest <= 0 ? " is-gratis" : "") }, [
        el("div", { class: "bp-meter__balk" }, [el("span", { style: "width:" + Math.min(100, Math.round((som / CTX.gratis) * 100)) + "%" })]),
        el("p", { class: "bp-meter__t" }, [rest > 0 ? vul(I.nog_voor_gratis, { bedrag: euro(rest) }) : I.gratis_bereikt]),
      ]);
    }
    var knop = el("button", { type: "button", class: "sw-knop bp-afrekenen", disabled: !staat.pakket.length, onclick: function (e) { allesInWagen(e.currentTarget); } }, [I.alles_in_wagen]);
    var deel = el("button", { type: "button", class: "sw-knop sw-knop--licht bp-deel", onclick: function (e) { delen(e.currentTarget); } }, [I.delen]);
    return el("div", { class: "bp-afreken" }, [
      el("div", { class: "bp-afreken__in" }, [
        el("p", { class: "bp-totaal" }, [el("span", {}, [I.totaal + " · " + vul(I.resultaat_titel, { n: staat.pakket.length })]), el("strong", {}, [prijs(som)])]),
        meter,
        el("div", { class: "sw-knoppen" }, [knop, deel, el("a", { class: "sw-naar-wagen", href: CTX.winkelwagen || "/cart", hidden: "" }, [I.naar_wagen])]),
      ]),
    ]);
  }

  // ---------- "Mail mij dit pakket" ----------
  // Bewust klein en ingeklapt onder de afrekenbalk: de oranje knop blijft de hoofdroute.
  // Stuurt het Klaviyo-event "Bierpakket Gemaild" (flow mailt direct, sjabloon Viqe42);
  // nieuwsbrief alleen met vinkje. NL/EN/DE: de flow kiest de mail op event.Taal.
  function mailMij() {
    if (!staat.pakket.length) return null;
    var vak = el("div", { class: "bp-mailmij" });
    if (staat.gemaild) {
      vak.appendChild(el("p", { class: "bp-mailmij__klaar" }, [vul(I.mail_klaar, { email: staat.gemaild })]));
      return vak;
    }
    var open = el("button", { type: "button", class: "bp-mailmij__link" }, [I.mail_link]);
    open.addEventListener("click", function () {
      vak.innerHTML = "";
      var email = el("input", { type: "email", required: true, autocomplete: "email", placeholder: I.mail_placeholder, value: CTX.email || null, "aria-label": I.mail_placeholder });
      var vink = el("input", { type: "checkbox" });
      var status = el("p", { class: "bp-mailmij__status", role: "status" });
      var knop = el("button", { type: "submit", class: "sw-knop sw-knop--licht sw-knop--klein" }, [I.mail_knop]);
      var form = el("form", { class: "bp-mailmij__form", novalidate: true }, [
        el("p", { class: "bp-mailmij__uitleg" }, [I.mail_uitleg]),
        el("div", { class: "bp-mailmij__rij" }, [email, knop]),
        el("label", { class: "bp-mailmij__vink" }, [vink, el("span", {}, [I.mail_vink])]),
        status,
      ]);
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var adres = (email.value || "").trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(adres)) { status.textContent = I.mail_ongeldig; return; }
        knop.disabled = true;
        status.textContent = "";
        stuurPakketMail(adres, vink.checked)
          .then(function () { staat.gemaild = adres; clearTimeout(updateTimer); render(); })
          .catch(function () { knop.disabled = false; status.textContent = I.mail_mislukt; });
      });
      vak.appendChild(form);
      email.focus();
    });
    vak.appendChild(open);
    return vak;
  }
  var KLAVIYO = "https://a.klaviyo.com/client/";
  var KLAVIYO_HDR = { "Content-Type": "application/vnd.api+json", revision: "2025-07-15" };
  function stuurPakketMail(adres, nieuwsbrief) {
    var props = Object.assign({ Gemaild: true, Voor: staat.voor || "mezelf", Taal: TAAL }, pakketEvent());
    var event = fetch(KLAVIYO + "events?company_id=V6BeY6", {
      method: "POST",
      headers: KLAVIYO_HDR,
      body: JSON.stringify({ data: { type: "event", attributes: {
        metric: { data: { type: "metric", attributes: { name: "Bierpakket Gemaild" } } },
        profile: { data: { type: "profile", attributes: { email: adres } } },
        properties: props,
      } } }),
    }).then(function (r) { if (!r.ok) throw new Error("klaviyo " + r.status); });
    var abonnement = !nieuwsbrief ? Promise.resolve() : fetch(KLAVIYO + "subscriptions?company_id=V6BeY6", {
      method: "POST",
      headers: KLAVIYO_HDR,
      body: JSON.stringify({ data: { type: "subscription", attributes: {
        custom_source: "Bierpakket samenstellen",
        profile: { data: { type: "profile", attributes: { email: adres } } },
      }, relationships: { list: { data: { type: "list", id: "Vp7gd9" } } } } }),
    }).catch(function () {}); // aanmelding mag mislukken zonder dat de pakketmail mislukt
    return Promise.all([event, abonnement]).then(function () {
      try { if (window.klaviyo && typeof window.klaviyo.identify === "function") window.klaviyo.identify({ email: adres }); } catch (e) {}
    });
  }

  // ---------- acties ----------
  function wissel(i) {
    var p = staat.pakket[i];
    p.geweigerd[p.b.h] = 1;
    var nieuw = kiesVoorPlek(i, staat.pakket, p.geweigerd, staat.pakket.length);
    if (!nieuw) {
      // alles al eens langsgekomen: begin de rij weer van voren
      p.geweigerd = {};
      p.geweigerd[p.b.h] = 1;
      nieuw = kiesVoorPlek(i, staat.pakket, p.geweigerd, staat.pakket.length);
    }
    if (!nieuw) { alert(I.geen_meer); return; }
    staat.pakket[i] = { b: nieuw, vast: false, p: null, geweigerd: p.geweigerd };
    na();
    kl("Bierpakket Bier Gewisseld", { Weg: p.b.h, Erin: nieuw.h });
  }
  function weghalen(i) {
    staat.pakket.splice(i, 1);
    na();
  }
  function bierErbij() {
    var i = staat.pakket.length;
    var b = kiesVoorPlek(i, staat.pakket, null, i + 1);
    if (!b) { alert(I.geen_meer); return; }
    staat.pakket.push({ b: b, vast: false, p: null, geweigerd: {} });
    na();
  }
  function opnieuwSamenstellen() {
    staat.vorige = {};
    staat.pakket.forEach(function (p) { if (!p.vast) staat.vorige[p.b.h] = 1; });
    staat.gedeeld = false;
    staat.vervangen = false;
    staat.pakket = stelSamen(staat.aantal || staat.pakket.length || 12);
    na();
  }
  function na() {
    laadProducten().then(function () {
      render();
      bewaarInUrl();
      meldPakketLater();
    });
  }

  function allesInWagen(knop) {
    knop.disabled = true;
    var oud = knop.textContent;
    knop.textContent = I.even_geduld;
    var items = staat.pakket
      .map(function (p) {
        var v = variant(p.p);
        return v ? { id: v.id, quantity: 1, properties: { _bierpakket: staat.id || "BP" } } : null;
      })
      .filter(Boolean);
    fetch(ROOT + "/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add");
        knop.textContent = I.toegevoegd;
        knop.classList.add("is-toegevoegd");
        clearTimeout(updateTimer); // in de winkelwagen: geen 'staat nog klaar'-update meer nodig
        kl("Bierpakket In Winkelwagen", { Totaal: totaal() / 100, Bieren: staat.pakket.map(function (p) { return p.b.h; }), Gedeeld: staat.gedeeld, Pakket: staat.id });
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        var link = knop.parentNode.querySelector(".sw-naar-wagen");
        if (link) link.hidden = false;
      })
      .catch(function () {
        knop.disabled = false;
        knop.textContent = oud;
        alert(I.toevoegen_mislukt);
      });
  }

  function delen(knop) {
    var url = pakketUrl();
    kl("Bierpakket Gedeeld");
    if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
      navigator.share({ title: I.start_titel, url: url }).catch(function () {});
      return;
    }
    var klaar = function () {
      var oud = knop.textContent;
      knop.textContent = "✓ " + I.gekopieerd;
      setTimeout(function () { knop.textContent = oud; }, 2500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(klaar, function () { window.prompt(I.delen, url); });
    else window.prompt(I.delen, url);
  }

  // ---------- start ----------
  if (leesUitUrl()) {
    root.innerHTML = "";
    root.appendChild(el("p", { class: "sw-laden bp-laden" }, [I.laden]));
    laadProducten().then(function () {
      render();
      kl("Bierpakket Geopend", { Gedeeld: true });
    });
  } else {
    // Doorgestuurd vanuit de Smaakwijzer-uitslag: smaak staat al vast
    var q = new URLSearchParams(window.location.search);
    if (q.get("smaak") && PROFIELEN[q.get("smaak")]) {
      staat.voor = q.get("voor") === "cadeau" ? "cadeau" : "mezelf";
      staat.smaak = q.get("smaak");
      gestart = true;
      kl("Bierpakket Gestart", { Bron: "smaakwijzer" });
      staat.stap = "soort";
    }
    render();
  }
})();
